{
  "name": "rokit-dmc",
  "version": "0.0.0-dev",
  "author": "ROKIT Team",
  "homepage": "https://rokitplace.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 5200",
    "dev": "npm run clean:cache && ng serve --port 5200",
    "stg": "npm run clean:cache && ng serve --configuration staging --port 5200",
    "clean:cache": "rm -rf .angular node_modules/.vite node_modules/.cache",
    "build": "ng build",
    "build:development": "ng build --configuration development",
    "build:staging": "ng build --configuration staging",
    "build:production": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "postinstall": "sh setup-hooks.sh",
    "sdk:link": "yalc add @saexpeditions/sdk",
    "sdk:unlink": "yalc remove --all && node scripts/remove-sdk-dependency.js && npm install",
    "sdk:check": "grep -q 'file:.yalc' package.json && echo '❌ Yalc activo' || echo '✅ Limpio'"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "21.1.0",
    "@angular/common": "21.1.0",
    "@angular/compiler": "21.1.0",
    "@angular/core": "21.1.0",
    "@angular/forms": "21.1.0",
    "@angular/platform-browser": "21.1.0",
    "@angular/router": "21.1.0",
    "@ng-icons/core": "33.1.0",
    "@ng-icons/heroicons": "33.1.0",
    "@ng-icons/ionicons": "33.1.0",
    "@ng-icons/lucide": "33.1.0",
    "rxjs": "7.8.0",
    "tailwind-merge": "3.4.0",
    "tslib": "2.3.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/schematics": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/build": "21.1.0",
    "@angular/cli": "21.1.0",
    "@angular/compiler-cli": "21.1.0",
    "@angular/language-service": "21.1.0",
    "@semantic-release/changelog": "6.0.3",
    "@semantic-release/git": "10.0.1",
    "@tailwindcss/postcss": "4.1.12",
    "@typescript-eslint/eslint-plugin": "8.52.0",
    "@typescript-eslint/parser": "8.52.0",
    "eslint": "9.16.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "48.2.1",
    "eslint-plugin-prefer-arrow": "1.2.2",
    "postcss": "8.5.3",
    "semantic-release": "24.2.4",
    "tailwindcss": "4.1.12",
    "typescript": "5.9.2"
  },
  "description": "Rokitplace DMC App"
}
